import { inject } from '@angular/core';
import { MixpanelService } from '../@services/mixpanel.service';
import { environment } from '../../environments/environment';

export function appMixpanelInitializer(): () => void {
  const mixpanelService = inject(MixpanelService);

  return (): void => {
    if (environment.mixpanelToken) {
      mixpanelService.initialize(environment.mixpanelToken);
    }
  };
}
